import { AxiosRequestConfig } from 'axios';
import { Genre } from '@/types/GenreTye';
import http from './api-client';

const apiEndpoint = '/genres';

/**
 * Fetches the list of games from the API.
 * @param signal - AbortSignal for canceling the request
 * @returns Promise containing the game list
 */
export const getGenres = async (config?: AxiosRequestConfig): Promise<Genre[]> =>
    await http
        .get<Genre[]>(apiEndpoint, { ...config })
        .then((res) => res.data);
